import React from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';

import { useDataStore } from 'state/DataStore';

import Page from 'components/Page';
import FeaturesContent from 'components/FeaturesContent';

const Features = observer(() => {
    const dataStore = useDataStore();
    const { unitTypeSlug } = useParams();

    const unitType = dataStore.getItem('unit_types', 'slug', unitTypeSlug);
    const colorScheme = unitType?.acf?.color_scheme;

    if (!unitType) {
        return (
            <Page>
                <p>No Unit Type Found</p>
            </Page>
        );
    }

    return (
        <Page>
            <FeaturesContent colorScheme={colorScheme} />
        </Page>
    );
});

export default Features;
